module.exports = __webpack_public_path__ + "media/images/commission_banner-efb5f0232d26b9198d92f9063730a003.png";